import styled from 'styled-components';
import colors, { opacity } from 'styles/colors';

export const CustomOptionsContainer = styled.div<{ isSelected?: boolean; isFocused?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  min-height: 40px;
`;

export const OptionContainer = styled.div<{ isFocused?: boolean }>`
  padding: 8px 12px;
  border-bottom: 1px solid #f0f0f0;

  background-color: ${(props) => {
    if (props.isFocused) return opacity(colors.fleetOffGray, 0.4);
    return colors.white;
  }};
  color: ${colors.fleetAlmostBlack};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-height: 40px;
  width: 100%;
`;

export const OptionName = styled.div`
  width: 120px;
`;

export const OptionEmail = styled.div`
  width: 180px;
`;

export const OptionPhone = styled.div`
  width: 120px;
`;

export const OptionAddress = styled.div`
  width: 200px;
`;

export const OptionCreate = styled.div<{ isFocused?: boolean }>`
  padding: 8px 12px;

  display: flex;
  align-items: center;
  min-height: 40px;
  width: 100%;

  background-color: ${(props) => {
    if (props.isFocused) return opacity(colors.fleetOffGray, 0.4);
    return colors.white;
  }};
`;
